import React from 'react';
import { connect } from 'react-redux';
import { ProfileComponent } from '../common/profile';

class Profile extends React.Component {
  render() {
    return <ProfileComponent {...this.props} />;
  }
}

function mapStateToProps(state) {
  const { user, permission, inventory, chat, vehicles } = state;
  return {
    user,
    permission,
    inventory,
    chat,
    vehicles,
  };
}

const connectedRegisterPage = connect(mapStateToProps)(Profile);
export { connectedRegisterPage as Profile }; 